import AnyAction from 'store/anyActions';

import WebSocketCompanionTypes from './websocketCompanion.types';
import WebsocketCompanionState from './websocketCompanion.state';

const defaultState = {
    client: null,
}

export default function (state: WebsocketCompanionState = defaultState, action: AnyAction): WebsocketCompanionState {
    switch (action.type) {
        case WebSocketCompanionTypes.CREATE_WEBSOCKET_COMPANION_CONNECTION:
            return {
                ...state,
                client: action.payload,
            };
        default:
            return state;
    }
}
